export default __webpack_public_path__ + "static/media/2.0755c513.png";